"use strict";

exports.__esModule = true;
exports.RenderItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var RenderItem = exports.RenderItem = function RenderItem(props) {
  var item = props.item,
    handleSelect = props.handleSelect,
    style = props.style;
  var getKey = props.getKey,
    renderItemText = props.renderItemText,
    renderItemLabel = props.renderItemLabel,
    isItemSelected = props.isItemSelected;
  var key = getKey(item);
  var isSelected = isItemSelected(item);
  return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    style: style,
    key: key,
    "data-testid": "MenuItem" + key,
    icon: /*#__PURE__*/_react["default"].createElement("span", {
      className: _core.Classes.CONTROL_INDICATOR
    }, isSelected ? /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.SMALL_TICK
    }) : /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.BLANK
    })),
    shouldDismissPopover: false,
    disabled: item && item.disabled ? item.disabled : false,
    text: renderItemText(item),
    label: renderItemLabel && /*#__PURE__*/_react["default"].createElement("small", null, renderItemLabel(item)),
    onClick: function onClick() {
      return handleSelect(item);
    }
  });
};